export const TRADE_WIDGET_TYPE_ID = 'TradeWidget';
